export default "https://d3nn82uaxijpm6.cloudfront.net/packs/media/apps/subscriptions/Checkout/components/Form/assets/mc-c0c910ffba74d13ebed1b4a78aaf54cc.svg";